<section class="landing-a__why">
  <div class="landing-a__container landing-a__why-grid">
    @for (item of whyItems; track item) {
      <article class="landing-a__why-item">
        <div class="landing-a__why-icon">
          <i-tabler [name]="whyIcons[item]"></i-tabler>
        </div>
        <h3>{{ 'landing.landing_1.why.items.' + item + '.title' | translate }}</h3>
        <p>{{ 'landing.landing_1.why.items.' + item + '.description' | translate }}</p>
      </article>
    }
  </div>
</section>
